import { FC, Suspense, lazy } from 'react';
import { PageDisplayEnum } from './BidHistoryModalTypes';

const BidHistoryModal = lazy(
    () => import(/* webpackChunkName: "BidHistoryModal" */ './BidHistoryModal')
);

type Props = {
    itemId: string;
    isOpen: boolean;
    currency: string;
    isClient: boolean;
    onClose: () => void;
    page?: PageDisplayEnum;
};

export const BidHistoryModalLazy: FC<Props> = ({ isClient, ...props }) => {
    if (!isClient) {
        return null;
    }
    return (
        <Suspense fallback={null}>
            <BidHistoryModal {...props} />
        </Suspense>
    );
};
